(() => {
  const script = document.currentScript;
  const gridSelector = '.t4s-products';
  const slotSelector = '[data-mu-extra-price-slot]';
  const pdpPriceSelector = '[data-mu-extra-pdp-price]';
  let scheduled = false;
  let pdpVariantEventsBound = false;

  const setColorSetting = (property, value) => {
    const normalizedValue = value?.trim();

    if (!normalizedValue || !window.CSS?.supports?.('color', normalizedValue)) return;

    document.documentElement.style.setProperty(property, normalizedValue);
  };

  setColorSetting('--mu-extra-badge-background', script?.dataset.muExtraBackground);
  setColorSetting('--mu-extra-badge-text-color', script?.dataset.muExtraTextColor);

  const updatePdpExtraPrice = (container, variant) => {
    if (!container || !variant) return;

    container.querySelectorAll(pdpPriceSelector).forEach((row) => {
      const price = Number(variant.price);
      const compareAtPrice = Number(variant.compare_at_price || price);
      const percent = Number(row.dataset.muExtraPercent);
      const isActive = Number.isFinite(price)
        && Number.isFinite(compareAtPrice)
        && Number.isFinite(percent)
        && compareAtPrice > price;
      const stack = row.closest('[data-mu-extra-pdp-stack]');
      const sourcePrice = stack?.querySelector('.t4s-product-price');

      row.classList.toggle('is-active', isActive);
      row.hidden = !isActive;
      row.setAttribute('aria-hidden', String(!isActive));
      sourcePrice?.classList.toggle('mu-extra-source-price', isActive);

      if (!isActive) return;

      const discountAmount = Math.floor((price * percent) / 100);
      const extraPrice = price - discountAmount;
      const priceElement = row.querySelector('[data-mu-extra-pdp-value]');
      const formatMoney = window.T4SThemeSP?.Currency?.formatMoney;

      if (priceElement && typeof formatMoney === 'function') {
        priceElement.innerHTML = formatMoney(extraPrice);
      }
    });
  };

  const isMainProductContainer = (container) => {
    if (!container) return false;

    try {
      return Boolean(JSON.parse(container.getAttribute('data-product-featured')).isMainProduct);
    } catch (_error) {
      return false;
    }
  };

  const updateStickyExtraPrice = (container, variant) => {
    if (!isMainProductContainer(container) || !variant) return;

    document.querySelectorAll('[data-sticky-addtocart] [data-mu-extra-sticky-price]').forEach((stickyPrice) => {
      const price = Number(variant.price);
      const compareAtPrice = Number(variant.compare_at_price || price);
      const percent = Number(stickyPrice.dataset.muExtraPercent);
      const formatMoney = window.T4SThemeSP?.Currency?.formatMoney;
      const isActive = Number.isFinite(price)
        && Number.isFinite(compareAtPrice)
        && Number.isFinite(percent)
        && compareAtPrice > price
        && typeof formatMoney === 'function';

      stickyPrice.classList.toggle('mu-extra-sticky-price', isActive);

      if (!isActive) return;

      const discountAmount = Math.floor((price * percent) / 100);
      const extraPrice = price - discountAmount;

      stickyPrice.innerHTML = [
        `<del class="mu-extra-sticky-compare">${formatMoney(compareAtPrice)}</del>`,
        `<del class="mu-extra-sticky-source">${formatMoney(price)}</del>`,
        `<ins class="mu-extra-sticky-final">${formatMoney(extraPrice)}</ins>`
      ].join('');
    });
  };

  const bindPdpVariantEvents = () => {
    const $ = window.jQuery_T4NT || window.jQuery;

    if (!$ || pdpVariantEventsBound) return;

    pdpVariantEventsBound = true;
    $(document).on('variant:changed.muExtraPrice', (event) => {
      const container = event.target?.closest?.('[data-product-featured]');
      updatePdpExtraPrice(container, event.currentVariant);
      updateStickyExtraPrice(container, event.currentVariant);
    });
  };

  const syncExtraPriceRows = () => {
    scheduled = false;

    document.querySelectorAll(gridSelector).forEach((grid) => {
      const hasVisibleExtra = Boolean(grid.querySelector(`${slotSelector}.is-active`));
      grid.classList.toggle('mu-extra-grid-active', hasVisibleExtra);
    });
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncExtraPriceRows);
  };

  const initialize = () => {
    scheduleSync();
    bindPdpVariantEvents();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
